// extracted by mini-css-extract-plugin
module.exports = {"card":"content-page_card__PfXBC typography_bodyFont__Sn75r","section":"content-page_section__NDP8i","heading":"content-page_heading__BM_wY"};